const loaded = new Set<string>();

export async function loadScript(src: string, id?: string) {
  if (id && document.getElementById(id)) return Promise.resolve();

  if (loaded.has(src)) return Promise.resolve();

  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.async = true;
    script.src = src;

    if (id) script.id = id;

    script.onload = () => {
      loaded.add(src);
      resolve();
    };

    script.onerror = reject;

    document.head.appendChild(script);
  });
}

export function appendPixel(url: string) {
  const img = new Image(1, 1);

  img.style.display = 'none';
  img.referrerPolicy = 'no-referrer-when-downgrade';
  img.src = url;

  document.body.appendChild(img);
}
